
import { ref, onMounted, watch, Ref } from "vue";
import { defineComponent } from "vue";
import Api from "../../services/Api";
import useAlert from "../../composables/Alert";
import Button from "@/components/Button.vue"
import { Modal } from "bootstrap";
import ModalPlanilhaFiltro from "./components/ModalPlanilhaFiltro.vue";
import axios from "axios";
import { uploadMediaFromClient } from "@/services/AzureService";
import { BlobItem, BlobServiceClient } from "@azure/storage-blob";
import ModalDownloadFiltro from "./components/ModalDownloadFiltro.vue";
import ModalUploadFiltro from "./components/ModalUploadFiltro.vue";
import { env } from "process";

export default defineComponent({
  name: "UploadPlanilhas",
  components: {
    Button,
    ModalPlanilhaFiltro,
    ModalDownloadFiltro,
    ModalUploadFiltro
  },

  setup() {
    const { showTimeAlert } = useAlert();
    const marcas: Ref<any> = ref([]);
    const historicoArquivos: Ref<any> = ref([]);
    const qtdArquivosSalvos: Ref<number> = ref(0)
    const historicoArquivosDownloads: Ref<any> = ref([]);
    const qtdArquivosSalvosDownloads: Ref<number> = ref(0)     
    const loaderListaDownload: Ref<boolean> = ref(false);
    const loaderListaUpload: Ref<boolean> = ref(false);

    const rodandoFila = ref(false)
    const alteraRodandoFila = () => rodandoFila.value = !rodandoFila.value

    const arquivoSelecionado: Ref<any> = ref("")
    const tipoSelecionado: Ref<any> = ref("")
    const modalPlanilhaFiltro: Ref<any> = ref()
    const modalDownloadPlanilhaFiltro: Ref<any> = ref()
    const modalUploadPlanilhaFiltro: Ref<any> = ref()


    async function getToken() {
      return localStorage.getItem('token_usuario');
    };

    function formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    async function getMarcas() {
      const { data } = await Api.get("getMarcasProdutoDbInfo", {tipoProduto: 'filtros'});
      if(data.length === 0) {
          marcas.value = [];
        } else {
          marcas.value = data;
        }
    }

    function formatDate(isoString) {
      const date = new Date(isoString);
      const day   = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year  = date.getFullYear();
      return `${day}/${month}/${year}`;
    }


    async function pegarListaDePlanilhas() {
      
      try{
        rodandoFila.value = true
        loaderListaUpload.value = true
        const result = await Api.get("retornaListaDeArquivos", { filePath: 'planilhas/filtros/', queueName: 'tabela_filtros' })
        if(!result.lista || result.lista.length === 0) {
          loaderListaUpload.value = false
          rodandoFila.value = false
          return showTimeAlert("Nenhum arquivo encontrado")
        } 

        const lista = result.lista
        //ordernar por data
        lista.sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())

        qtdArquivosSalvos.value = lista.length;
        historicoArquivos.value = lista.slice(0, 10);
        }catch(error){
        console.log('Erro ao pegar lista de planilhas', error)
        showTimeAlert("Erro ao pegar lista de planilhas", "error")
      }finally{
        loaderListaUpload.value = false
        rodandoFila.value = false
      }
    }
    async function pegarListaPlanilhaFiltroDatabase() {
      
      try{
        rodandoFila.value = true
        loaderListaDownload.value = true
        const result = await Api.get("pegarListaPlanilhaFiltroDatabase", { filePath: 'planilhas/relatorios/' })
        if(!result.lista || result.lista.length === 0) {
          loaderListaDownload.value = false
          rodandoFila.value = false
          return showTimeAlert("Nenhum arquivo encontrado")
        } 

        const lista = result.lista
        //ordernar por data
        lista.sort((a, b) => new Date(b.data).getTime() - new Date(a.data).getTime())

        qtdArquivosSalvosDownloads.value = lista.length;
        historicoArquivosDownloads.value = lista.slice(0, 10);
        }catch(error){
        console.log('Erro ao pegar lista de planilhas', error)
        showTimeAlert("Erro ao pegar lista de planilhas", "error")
      }finally{
        loaderListaDownload.value = false
        rodandoFila.value = false
      }
    }

    //////////////// MODAL DOWNLOAD PLANILHA ////////////////////

    function abreModalDownload(arquivo?: any) {
      arquivoSelecionado.value = arquivo || {}
      modalDownloadPlanilhaFiltro.value.show()
    }

    function abreModalUpload() {
      modalUploadPlanilhaFiltro.value.show()
    }

    function fechaModalUpload() {
      modalUploadPlanilhaFiltro.value.hide()
    }

    function fechaModalDownload() {
      arquivoSelecionado.value = ""
      modalDownloadPlanilhaFiltro.value.hide()
    }

    //////////////// MODAL DOWNLOAD PLANILHA ////////////////////

    ///////////////////// MODAL PRODUTO LOG /////////////////////

    function abreModal(arquivo?: any, tipo?: string) {
      arquivoSelecionado.value = arquivo || {}
      tipoSelecionado.value = tipo
      modalPlanilhaFiltro.value.show()
    }

    async function fechaModal() {
      arquivoSelecionado.value = {}
      modalPlanilhaFiltro.value.hide()
    }

    ///////////////////// MODAL PRODUTO LOG /////////////////////

    // watch(() => rodandoFila.value, async () => { pegarListaDePlanilhas() }, { deep: true })

    onMounted(async() => {

      modalPlanilhaFiltro.value = new Modal(document.querySelector(`#ModalPlanilhaFiltro`));
      modalDownloadPlanilhaFiltro.value = new Modal(document.querySelector(`#ModalDownloadFiltro`));
      modalUploadPlanilhaFiltro.value = new Modal(document.querySelector(`#ModalUploadFiltro`));
      
      getMarcas()
      pegarListaDePlanilhas()
      pegarListaPlanilhaFiltroDatabase()
    })

    return {
      marcas,
      historicoArquivos,
      formatBytes,
      history,
      qtdArquivosSalvos,
      abreModal,
      fechaModal,
      arquivoSelecionado,
      tipoSelecionado,
      rodandoFila,
      alteraRodandoFila,
      loaderListaDownload,
      loaderListaUpload,
      formatDate,
      pegarListaDePlanilhas,
      abreModalDownload,
      fechaModalDownload,
      abreModalUpload,
      fechaModalUpload,
      pegarListaPlanilhaFiltroDatabase,
      qtdArquivosSalvosDownloads,
      historicoArquivosDownloads
    }
  },
});
